<template>
  <div style="margin: 10px; border: 1px solid #eee; padding: 0 10px; border-radius: 5px">
    <div class="title">
      <div class="title">
        <strong>店铺排名分析</strong>
        <el-tooltip class="item" effect="dark" placement="top-start" :open-delay="1000">
          <span class="el-icon-warning-outline"></span>
          <div slot="content">
            总分100分制，如果全网总数据得分在80分及以上，则无论各店铺得分情况如何均不做考核<br />数据更新时间截至次月3号，3号后的订单是否退款不会影响排名
          </div>
        </el-tooltip>
        <el-button type="text" @click="assessmentRules">考核规则</el-button>
      </div>
    </div>
    <div class="banner">
      <div class="shop-boxone" v-if="tableData[1] && tableData[1].platformName">
        <img :src="require(`../../../../../../assets/images/shop/shop-${tableData[1].platformName}.png`)" alt="" />
        <div>{{ tableData[1].storeName }}</div>
      </div>
      <div class="shop-boxtwo" v-if="tableData[0] && tableData[0].platformName">
        <img :src="require(`../../../../../../assets/images/shop/shop-${tableData[0].platformName}.png`)" alt="" />
        <div>{{ tableData[0].storeName }}</div>
      </div>
      <div class="shop-boxthere" v-if="tableData[2] && tableData[2].platformName">
        <img :src="require(`../../../../../../assets/images/shop/shop-${tableData[2].platformName}.png`)" alt="" />
        <div>{{ tableData[2].storeName }}</div>
      </div>
      <img src="../../../../../../assets/images/banner.png" alt="" class="banner-img" />
    </div>
    <el-table :data="tableData" border :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }" v-if="radio == '日'">
      <el-table-column label="排名" prop="rankingNum" align="center">
        <template slot-scope="scope">
          <img
            :src="require(`../../../../../../assets/images/ranking-${scope.row.rankingNum}.png`)"
            alt=""
            style="vertical-align: middle"
            v-if="
              (scope.row.rankingNum == 1 || scope.row.rankingNum == 2 || scope.row.rankingNum == 3) && scope.row.platformName && scope.row.storeName.length > 2
            "
          />
          <spam
            v-else-if="
              scope.row.rankingNum != 1 && scope.row.rankingNum != 2 && scope.row.rankingNum != 3 && scope.row.platformName && scope.row.storeName.length > 2
            "
          >
            {{ scope.row.rankingNum }}</spam
          >
        </template>
      </el-table-column>
      <el-table-column label="店铺" prop="storeName"></el-table-column>
      <el-table-column label="达成率" prop="achievementRate"></el-table-column>
      <el-table-column label="达成率得分" prop="achievementRateScore"></el-table-column>
      <el-table-column label="超卖率(当前应售)" prop="oversoldRate1"></el-table-column>
      <el-table-column label="超卖得分(当前应售)" prop="oversoldRateScore1"></el-table-column>
      <el-table-column label="超卖产品比例" prop="oversoldProportion"></el-table-column>
      <el-table-column label="超卖产品得分" prop="oversoldProportionScore"></el-table-column>
      <el-table-column label="积压产品比例" prop="backlogProportion"></el-table-column>
      <el-table-column label="积压产品得分" prop="backlogProportionScore"></el-table-column>
      <el-table-column label="总分" prop="totalScore"></el-table-column>
    </el-table>
    <el-table :data="tableData" border :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }" v-if="radio == '月' || radio == '季度' || radio == '自定义'">
      <el-table-column label="排名" prop="rankingNum" align="center">
        <template slot-scope="scope">
          <img
            :src="require(`../../../../../../assets/images/ranking-${scope.row.rankingNum}.png`)"
            alt=""
            style="vertical-align: middle"
            v-if="
              (scope.row.rankingNum == 1 || scope.row.rankingNum == 2 || scope.row.rankingNum == 3) && scope.row.platformName && scope.row.storeName.length > 2
            "
          />
          <spam
            v-else-if="
              (scope.row.rankingNum != 1 || scope.row.rankingNum != 2 || scope.row.rankingNum != 3) && scope.row.platformName && scope.row.storeName.length > 2
            "
          >
            {{ scope.row.rankingNum }}</spam
          >
        </template>
      </el-table-column>
      <el-table-column label="店铺" prop="storeName"></el-table-column>
      <el-table-column label="达成率" prop="achievementRate"></el-table-column>
      <el-table-column label="达成率得分" prop="achievementRateScore"></el-table-column>
      <el-table-column label="超卖率(全月)" prop="oversoldRate2"></el-table-column>
      <el-table-column label="超卖得分(全月)" prop="oversoldRateScore2"></el-table-column>
      <el-table-column label="超卖产品比例" prop="oversoldProportion"></el-table-column>
      <el-table-column label="超卖产品得分" prop="oversoldProportionScore"></el-table-column>
      <el-table-column label="积压产品比例" prop="backlogProportion"></el-table-column>
      <el-table-column label="积压产品得分" prop="backlogProportionScore"></el-table-column>
      <el-table-column label="总分" prop="totalScore"></el-table-column>
    </el-table>
    <!-- <div class="tips">说明：上述数据均为常规销售产品（不含新品、库存清理）预估及实销数据</div> -->
    <el-dialog :visible.sync="recordDialogVisible" title="考核规则" width="45%">
      <div class="rule_box">
        <el-table
          :data="rulesTableData"
          v-loading="loading2"
          border
          :height="500"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="name" label="指标" width="180px"></el-table-column>
          <el-table-column prop="ruleDesc" label="得分规则"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'table-analysis-3',
  props: ['form', 'radio'],
  data() {
    return {
      columnData: [],
      originData: [],
      tableData: [],
      tips: '',
      recordDialogVisible: false,
      rulesTableData: [],
      loading2: false,
    };
  },
  computed: {
    tableCloumn() {},
  },
  mounted() {
    this.init();
  },
  methods: {
    init(months) {
      console.log(months);
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.3)",
      });
      this.$q.preSalePlan
        .rankingList({
          params: {
            months: months || '',
            planTime: this.form.planTime,
            type: this.radio == '日' ? 1 : this.radio == '月' ? 2 : this.radio == '年' ? 3 : this.radio == '季度' ? 4 : 5,
          },
        })
        .then((res) => {
          if (res.data && res.code == 200) {
            this.tableData = res.data;
          } else {
            this.tableData = [];
          }
        }).finally(_=>{
          loading.close()
        });
    },
    assessmentRules() {
      this.recordDialogVisible = true;
      this.loading2 = true;
      this.$q.preSalePlan
        .assessmentRulesList({})
        .then((res) => {
          console.log(res);
          if (res.data) {
            let tableNum = [res.data.achievementRate, res.data.oversoldRate, res.data.oversoldProportion, res.data.backlogProportion];
            let name = ['达成率', '超卖率', '超卖产品比例', '积压产品比例'];
            let data = [];
            let table1 = [];
            let table2 = [];
            let table3 = [];
            let table4 = [];
            res.data.achievementRate.forEach((v) => {
              console.log(v.ruleDesc);
              table1.push(`${v.ruleDesc}\n`);
            });
            res.data.oversoldRate.forEach((v) => {
              table2.push(`${v.ruleDesc}\n`);
            });
            res.data.oversoldProportion.forEach((v) => {
              table3.push(`${v.ruleDesc}\n`);
            });
            res.data.backlogProportion.forEach((v) => {
              table4.push(`${v.ruleDesc}\n`);
            });
            tableNum = [table1, table2, table3, table4];
            console.log(tableNum);
            name.forEach((v, index) => {
              data.push({
                name: name[index],
                ruleDesc: tableNum[index],
              });
            });
            this.rulesTableData = data;
          } else {
            this.recordData = [];
          }
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.title {
  color: #444;
  margin: 10px 0;
}

.title strong {
  font-size: 16px;
}

.tips {
  color: #777;
  margin: 10px 0;
}

>>>.high-light {
  td {
    color: #FF3300;
  }

  td:first-child {
    color: #606266;
  }
}

.banner {
  position: relative;
}

.banner-img {
  width: 100%;
  padding-bottom: 10px;
}

.shop-boxone {
  height: 2.12vw;
  position: absolute;
  top: 35%;
  left: 31%;
  line-height: 2.12vw;
}

.shop-boxtwo {
  height: 2.63vw;
  position: absolute;
  top: 13%;
  left: 47%;
  line-height: 2.63vw;
}

.shop-boxthere {
  height: 2vw;
  position: absolute;
  top: 42%;
  left: 65%;
  line-height: 2vw;
}

.shop-boxone img {
  width: 2.12vw;
  height: 2.12vw;
  float: left;
  padding-right: 0.52vw;
}

.shop-boxtwo img {
  width: 2.63vw;
  height: 2.63vw;
  float: left;
  padding-right: 0.52vw;
}

.shop-boxthere img {
  width: 2vw;
  height: 2vw;
  float: left;
  padding-right: 0.52vw;
}

.shop-boxone div {
  font-size: 0.7vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 800;
  display: inline-block;
  color: #0BB78E;
  float: left;
}

.shop-boxtwo div {
  font-size: 0.8vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 800;
  display: inline-block;
  color: #0BB78E;
  float: left;
}

.shop-boxthere div {
  font-size: 0.65vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 800;
  display: inline-block;
  color: #0BB78E;
  float: leftw;
}

.rule_box >>> .el-table .cell {
  white-space: pre-line;
}
</style>
